import { TemplateId } from '@cibli/shared';

import type { RegisteredTemplate } from '../types';

import EleganceDisplay from './Display';
import EleganceEditPannel from './EditPannel';
import { eleganceDefaultParams, eleganceParamsSchema } from './schema';

const eleganceTemplate: RegisteredTemplate<typeof eleganceDefaultParams> = {
  meta: {
    id: 'onepage' as TemplateId,
    name: 'Élégance',
  },
  schema: eleganceParamsSchema,
  defaults: eleganceDefaultParams,
  Display: EleganceDisplay as unknown as RegisteredTemplate<
    typeof eleganceDefaultParams
  >['Display'],
  EditPannel: EleganceEditPannel as unknown as RegisteredTemplate<
    typeof eleganceDefaultParams
  >['EditPannel'],
  pdfOptions: {
    printBackground: true,
  },
};

export default eleganceTemplate;
